export function getExecutionProgressLabel(
  eventType: string,
  options: { hasToolResults?: boolean } = {},
): string | null {
  const hasToolResults = Boolean(options.hasToolResults);

  switch (eventType) {
    case 'execution_started':
      return 'Understanding your request';
    case 'tools_loaded':
    case 'iteration_started':
    case 'llm_thinking':
      return hasToolResults
        ? 'Combining the results'
        : 'Preparing the analysis';
    case 'tool_call':
    case 'tool_result':
      return 'Gathering the required evidence';
    default:
      return null;
  }
}